<template>
    <side-bar :background-color="sidebarBackground" short-title="SchoolDock" title="SchoolDock"
        v-if="accessDetails && staffDetails">
        <template slot="links" v-if="staffDetails">
            <sidebar-item :link="{
                name: 'Dashboard',
                icon: 'fa fa-tv text-primary',
                path: '/dashboard',
            }" />

            <sidebar-item :link="{
                name: 'Academic Management',
                icon: 'fa fa-sliders-h text-blue',
                path: '/school/academic-management',
            }" v-if="staffDetails.isPortalAdmin == true  || staffDetails.isPrincipal == true" />

            <sidebar-item :link="{
                name: 'Admission Management',
                icon: 'fa fa-ticket text-blue',
                path: '/school/admission',
            }" v-if="staffDetails.isPortalAdmin == true || staffDetails.isRegistrar == true" />

            <sidebar-item :link="{
                name: 'Attendance Management',
                icon: 'fa fa-user-clock text-blue',
                path: '/school/attendance-management',
            }" v-if="staffDetails.isPortalAdmin == true || staffDetails.isClassTeacher == true || staffDetails.isDailyAttendanceManager == true" />

            <sidebar-item :link="{
                name: 'Career & Guidance',
                icon: 'fa fa-graduation-cap text-blue',
                path: '/school/career-and-guidance',
            }" v-if="staffDetails.isPortalAdmin == true || staffDetails.isPrincipal == true" />

            <sidebar-item :link="{
                name: 'Certificates',
                icon: 'fa fa-certificate text-blue',
                path: '/school/certificates',
            }" v-if="staffDetails.isPortalAdmin == true || staffDetails.isPrincipal == true" />

            <sidebar-item :link="{
                name: 'Communication',
                icon: 'fa fa-comments text-blue',
                path: '/school/communication',
            }" v-if="staffDetails.isPortalAdmin == true || staffDetails.isPrincipal == true" />

            <sidebar-item :link="{
                name: 'Discipline Management',
                icon: 'fa fa-gavel text-blue',
                path: '/school/discipline-management',
            }" v-if="staffDetails.isPortalAdmin == true || staffDetails.isPrincipal == true" />

            <sidebar-item :link="{
                name: 'Document Management',
                icon: 'fa fa-folder text-blue',
                path: '/school/document-management',
            }" v-if="staffDetails.isPortalAdmin == true || staffDetails.isPrincipal == true" />

            <sidebar-item :link="{
                name: 'Events Management',
                icon: 'fa fa-calendar text-blue',
                path: '/school/events-management',
            }" v-if="staffDetails.isPortalAdmin == true || staffDetails.isPrincipal == true" />

            <sidebar-item :link="{
                name: 'Examination & Assessment',
                icon: 'fa fa-computer text-blue',
                path: '/school/examination-and-assessment',
            }" v-if="staffDetails.isPortalAdmin == true || staffDetails.isPrincipal == true || staffDetails.isHOD == true || staffDetails.isClassTeacher == true || staffDetails.isSubjectTeacher == true" />

            <sidebar-item :link="{
                name: 'Finance Management',
                icon: 'fa fa-hand-holding-dollar text-blue',
                path: '/school/finance-management',
            }" v-if="staffDetails.isPortalAdmin == true || staffDetails.isPrincipal == true || staffDetails.isBursar == true" />

          
            <sidebar-item :link="{
                name: 'Health Management',
                icon: 'fa fa-heartbeat text-blue',
                path: '/school/health-management',
            }" v-if="staffDetails.isPortalAdmin == true || staffDetails.isPrincipal == true" />

            <sidebar-item :link="{
                name: 'Hostel Management',
                icon: 'fa fa-bed text-blue',
                path: '/school/hostel-management',
            }" v-if="staffDetails.isPortalAdmin == true || staffDetails.isHostelMaster == true" />

            <sidebar-item :link="{
                name: 'Inventory & Assets',
                icon: 'fa fa-boxes text-blue',
                path: '/school/inventory-and-assets',
            }" v-if="staffDetails.isPortalAdmin == true || staffDetails.isPrincipal == true" />

            <sidebar-item :link="{
                name: 'Learning Management',
                icon: 'fa fa-book-reader text-blue',
                path: '/school/learning-management',
            }" v-if="staffDetails.isPortalAdmin == true || staffDetails.isPrincipal == true || staffDetails.isHOD == true || staffDetails.isClassTeacher == true || staffDetails.isSubjectTeacher == true" />

            <sidebar-item :link="{
                name: 'Library Management',
                icon: 'fa fa-book text-blue',
                path: '/school/library-management',
            }" v-if="staffDetails.isPortalAdmin == true || staffDetails.isLibraryAdmin == true" />

            <sidebar-item :link="{
                name: 'Reports & Analytics',
                icon: 'fa fa-chart-line text-blue',
                path: '/school/reports-and-analytics',
            }" v-if="staffDetails.isPortalAdmin == true || staffDetails.isPrincipal == true || staffDetails.isClassTeacher == true" />

            <sidebar-item :link="{
                name: 'School Details',
                icon: 'fa fa-school text-blue',
                path: '/school/school-details',
            }" v-if="staffDetails.isPortalAdmin == true || staffDetails.isPrincipal == true" />

            <sidebar-item :link="{
                name: 'School Website CMS',
                icon: 'fa fa-globe text-blue',
                path: '/school/school-website',
            }" v-if="staffDetails.isPortalAdmin == true || staffDetails.isPrincipal == true" />

            <sidebar-item :link="{
                name: 'Staff Information',
                icon: 'fa fa-id-card text-blue',
                path: '/school/staff-management',
            }" v-if="staffDetails.isPortalAdmin == true || staffDetails.isRegistrar == true || staffDetails.isPrincipal == true || staffDetails.isHOD == true" />

            <sidebar-item :link="{
                name: 'Student Information (SIS)',
                icon: 'fa fa-id-card text-blue',
                path: '/school/student-information-system',
            }" v-if="staffDetails.isPortalAdmin == true || staffDetails.isRegistrar == true || staffDetails.isPrincipal == true || staffDetails.isHOD == true" />

            <sidebar-item :link="{
                name: 'Subscription',
                icon: 'fa fa-credit-card text-blue',
                path: '/school/subscription',
            }" v-if="staffDetails.isPortalAdmin == true || staffDetails.isPrincipal == true" />

            <sidebar-item :link="{
                name: 'Timetable Management',
                icon: 'fa fa-calendar text-blue',
                path: '/school/timetable-management',
            }" v-if="staffDetails.isPortalAdmin == true || staffDetails.isPrincipal == true || staffDetails.isHOD == true" />

            <sidebar-item :link="{
                name: 'Transport Management',
                icon: 'fa fa-bus text-blue',
                path: '/school/transport-management',
            }" v-if="staffDetails.isPortalAdmin == true || staffDetails.isPrincipal == true" />

            <div class="dropdown-divider"></div>
            <sidebar-item :link="{ name: 'Log Out', icon: 'fa fa-right-from-bracket text-blue', path: '/' }"
                @click="logout" />
        </template>
    </side-bar>
</template>
<script>
export default {
    data() {
        return {
            sidebarBackground: "vue", //vue|blue|orange|green|red|primary
            accessDetails: null,
            staffDetails: null,
            onloader: "none",
        };
    },
    methods: {
        logout() {
            this.$store.dispatch("auth/Logout").then(() => {
                console.log('User logged out');
                this.$router.push("/login");
            });
        },
    },
    mounted() {
        this.accessDetails = this.$store.getters['auth/_user'];
        this.staffDetails = this.$store.getters['SchoolStaff/_schoolStaff'];
    },
};
</script>
